<template>
  <v-container
    class="fill-height"
  >
    <v-row
      justify="center"
      align="center"
    >
      <v-col
        cols="12"
        md="8"
      >
        <v-card class="elevation-5 mb-5">
          <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <v-form @submit.prevent="handleSubmit(submit)">
              <v-toolbar
                color="indigo"
                class="lighten-1"
                dark
                flat
              >
                <v-toolbar-title>Вход<span class="hidden-md-and-down"> в личный кабинет</span></v-toolbar-title>
              </v-toolbar>
              <v-card-text>

                <ValidationProvider name="detail" v-slot="{ errors }">
                  <v-alert
                    dense
                    outlined
                    type="error"
                    v-if="errors[0]"
                  >
                    <div v-html="errors[0]" class="caption"></div>
                  </v-alert>
                </ValidationProvider>

                <v-text-field
                  style="display: none"
                  autocomplete="email password"
                ></v-text-field>

                <ValidationProvider name="email" ref="emailProvider" rules="required|email|max:254" v-slot="{ errors }">
                  <v-text-field
                    name="email"
                    v-model="email"
                    :error-messages="errors"
                    type="text"
                    label="Электронная почта"
                  ></v-text-field>
                </ValidationProvider>

                <ValidationProvider name="password" ref="passwordProvider" rules="required|min:8|max:128"
                                    v-slot="{ errors }">
                  <v-text-field
                    id="password"
                    v-model="password"
                    :error-messages="errors"
                    type="password"
                    label="Пароль"
                    autocomplete="new-password"
                  ></v-text-field>
                </ValidationProvider>

              </v-card-text>
              <v-card-actions>
                <help-login></help-login>
                <v-spacer></v-spacer>
                <v-btn
                  right
                  dark
                  class="lighten-1"
                  color="ma-2 indigo"
                  type="submit"
                  :loading="isLoading"
                >
                  Вход
                </v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {extend, localize, ValidationObserver, ValidationProvider} from 'vee-validate';
  import "@/_plugins/vee-validate";
  import HelpLogin from '@/components/auth/dialogs/HelpLogin'
  import {mapGetters} from "vuex";
  import {email, max, min, required} from 'vee-validate/dist/rules';

  export default {
    name: "Login",
    components: {
      ValidationObserver,
      ValidationProvider,
      HelpLogin
    },
    data() {
      return {
        email: '',
        password: '',
      }
    },
    computed: {
      ...mapGetters("context", [
        'isLoading',
        'messages',
      ])
    },
    watch: {
      email() {
        this.$refs.observer.reset();
      },
      password() {
        this.$refs.observer.reset();
      }
    },
    methods: {
      async submit() {
        await this.$refs.observer.validate().then(success => {
          if (!success) {
            return;
          }

          const {email, password} = this;
          this.$store.commit("context/CLEAR_MESSAGES");
          this.$store.dispatch('auth/login', {email, password})
            .then(() => {
              if (this.messages) {
                this.$refs.observer.setErrors(this.messages);
              } else if (!this.messages) {
                this.$router.push({name: 'profile'})
                  .catch(() => {
                  })
              }
            })
            .catch(() => {
              this.$refs.observer.setErrors({
                'detail': 'Неизвестная ошибка. Обратитесь в поддержку: <a href="mailto:abit@kuzstu.ru">abit@kuzstu.ru</a>',
                'email': ' ',
                'password': ' ',
              });
            });

          this.password = ''
          this.$nextTick(() => {
            this.$refs.observer.reset();
          });
        });
      }
    }
  }

  localize({
    ru: {
      names: {
        email: ' ',
        password: ' ',
      }
    }
  });
  extend('required', {
    ...required
  });
  extend('email', {
    ...email
  });
  extend('min', {
    ...min
  });
  extend('max', {
    ...max
  });
</script>
